<template>
  <v-container fluid class="custom-container">

    <!-- Folders Header -->
    <v-layout
      justify-space-between
      align-center
      v-if="folders && folders.length > 0"
    >
      <folder-status-cards :folders="folders" :counts="sentCounts" context="sent"/>
    </v-layout>
    <v-layout
      v-if="folders && folders.length > 0"
      class="list-folders-actions justify-space-aroun align-center" row wrap
    >
      <v-flex xs6 class="align-center">
        <div>
          <span class="mr-2">Exibindo {{ pageStart }} - {{ pageStop }} de {{ foldersCount }}</span>
          <v-btn icon small @click="pageNumber--" :disabled="pageNumber <= 1">
            <v-icon>chevron_left</v-icon>
          </v-btn>
          <v-btn icon small @click="pageNumber++" :disabled="pageNumber >= pages">
            <v-icon>chevron_right</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs6 style="text-align: end;">
        <v-btn-toggle v-model="viewMode" mandatory dense>
          <v-btn flat small :value="'list'">
            <v-icon>mdi-format-list-bulleted</v-icon>
          </v-btn>
          <!-- <v-btn flat small :value="'grid'">
            <v-icon>mdi-grid</v-icon>
          </v-btn>-->
        </v-btn-toggle>
      </v-flex>
    </v-layout>

    <!-- Folders -->
    <section class="folders" v-if="Object.keys(groupedFolders).length > 0">
      <!-- Lista -->
      <template v-if="viewMode === 'list'">
        <v-layout
          class="folder-list mb-3"
          v-for="(group,index) in groupedFolders"
          :key="index"
          column
        >
          <span
            class="subheading grey--text mt-3 mb-3 text-capitalize"
          >
            {{ index }}
          </span>

          <div class="elevation-1 group" v-if="group.length > 0">
            <draggable :options="{ delay: dragDelay }">
              <transition-group
                name="fade-cascade"
                tag="div"
                class="cascade-group"
                appear
              >
                <folder-card
                  v-for="(folder, folderIndex) in group"
                  :key="`${folder.id}-${folderIndex}`"
                  :folder="folder"
                  :draggingItemId="draggingItemId"
                  :style="{ '--cascade-delay': `${folderIndex * 0.05}s` }"
                  @update:draggingItemId="id => draggingItemId = id"
                  @drag-start="startDrag"
                  @open-folder="openFolder"
                />
              </transition-group>
            </draggable>
          </div>
        </v-layout>
      </template>

      <!-- Grid -->
      <template v-else>
        <v-layout
          class="folder-list mb-3"
          v-for="(group,index) in groupedFolders"
          :key="index"
          column
        >
          <span
            class="subheading grey--text mt-3 mb-3 text-capitalize"
          >
            {{ index }}
          </span>

          <folder-grid
            :folders="group"
            v-if="group.length > 0"
          />
        </v-layout>
      </template>
    </section>

    <!-- Empty Content -->
    <v-container fill-height v-if="Object.keys(groupedFolders).length === 0 && !loading.show">
      <v-layout column align-center justify-center>
        <v-icon class="mb-2" size="48" color="grey darken-2">mdi-send</v-icon>
        <span class="title font-weight-regular grey--text text--darken-2">
          Não há itens para exibir
        </span>
      </v-layout>
    </v-container>

  </v-container>
</template>


<script>
import {isEmpty, truncate, get} from "lodash";
import acronym from "@/utils/acronym";
import shortName from "@/utils/short-name";
import format from "date-fns/format";
import * as ptLocale from "date-fns/locale/pt";
import FolderStatusCards from "@/components/folder/FolderStatusCards";
import getColorByText from '@/assets/utils/colorByText';
import draggable from "vuedraggable";
import foldersService from '@/services/FoldersService';
import {getFolderStatus} from "../../../../mixins/folder-status";

export default {
  name: "sent",
  components: {
    FolderStatusCards,
    draggable,
    FolderCard: () => import('@/components/folder/FolderCard'),
    FolderGrid: () => import('@/components/folder/FolderGrid')
  },
  mounted() {
    this.getFolders();
  },
  data() {
    return {
      firstRender: true,
      truncateText: truncate,
      shortName,
      isEmpty,
      get,
      pageNumber: 1,
      rowsPerPage: 20,
      draggingItemId: null,
      timer: null,
      dragDelay: 1500,
      retryCount: 0,
      maxRetries: 3,
      viewMode: 'list', // 'list' ou 'grid'
      isLoadingFolders: false,  // Flag para controlar requisições simultâneas
      orderFilter: {
        name: "Tramitação mais recente",
        property: "effective_updated_at",
        order: "desc"
      },
      orderFilters: [
        // {name: "Menor prazo", property: "limit_date", order: "asc"},
        // {name: "Maior prazo", property: "limit_date", order: "desc"},
        {
          name: "Tramitação mais antiga",
          property: "effective_updated_at",
          order: "asc"
        },
        {
          name: "Tramitação mais recente",
          property: "effective_updated_at",
          order: "desc"
        },
        // {
        //   name: "Por Setor",
        //   property: "administrative_unit",
        //   order: "asc"
        // }
      ],
    };
  },
  methods: {
    startDrag(id) {
      this.$store.commit("setDraggingFolder", id);
    },
    startTimer(id) {
      this.timer = setTimeout(() => {
        this.setDraggingItem(id);
      }, this.dragDelay);
    },
    stopTimer() {
      clearTimeout(this.timer);
      this.setDraggingItem(null);
    },
    setDraggingItem(id) {
      this.draggingItemId = id;
    },
    acronym(string) {
      return acronym(string);
    },
    currentUserIsOwner(currentOwner) {
      return this.user.id === currentOwner.id;
    },
    getFolders(showLoader = true) {
      // Evita requisições simultâneas
      if (this.isLoadingFolders) {
        console.log('Requisição já em andamento. Ignorando nova requisição de getFolders.')
        return;
      }

      this.isLoadingFolders = true;

      if (showLoader) {
        this.$store.dispatch("toggleLoader", {show: true});
      }

      this.$store
        .dispatch("getFoldersSent", {
          page: this.pageNumber,
          limit: this.rowsPerPage,
          searchText: this.searchText || "",
          administrativeUnitId: this.selectedAdministrativeUnit || ""
        })
        .then(() => {
          // Garantir que as pastas foram carregadas corretamente
          if (this.folders.length === 0 && this.foldersCount > 0 && this.retryCount < this.maxRetries) {
            console.log(`Tentando recuperar pastas novamente (tentativa ${this.retryCount + 1} de ${this.maxRetries})...`);
            // Tentar recuperar pastas novamente se necessário com delay progressivo
            this.retryCount++;
            setTimeout(() => {
              this.isLoadingFolders = false; // Reseta flag antes da nova tentativa
              this.getFolders();
            }, 500 * this.retryCount);
          } else {
            // Resetar contador de tentativas após sucesso ou máximo de tentativas
            this.retryCount = 0;
            this.isLoadingFolders = false;
          }
        })
        .catch(error => {
          console.error('Erro ao buscar pastas enviadas:', error);
          this.$store.dispatch("toggleSnackbar", {
            show: true,
            timeout: 6000,
            color: "error",
            message: "Erro ao carregar pastas enviadas. Tente novamente.",
            messageIcon: "mdi-alert-outline"
          });
          this.isLoadingFolders = false;
        })
        .finally(() => {
          this.$store.dispatch("toggleLoader", {show: false});
          this.$store.dispatch("setLoadingSearchText", false);
          this.isLoadingFolders = false;
        });
    },
    openFolder(id) {
      const route = this.$router.resolve(`/pastas/${id}/show`);
      window.open(route.href, "_blank");
    },
    formatDate(date) {
      return format(date, "DD/MM/YYYY");
    },
    formatMonthYear(date) {
      return format(date, "MMMM [de] YYYY", {locale: ptLocale});
    },
    hour(date) {
      return format(date, "HH:mm", {locale: ptLocale});
    },
    truncateEntityName(entityName) {
      if (this.$vuetify.breakpoint.lgOnly) {
        return truncate(entityName, {length: 25});
      }
      if (this.$vuetify.breakpoint.xlOnly) {
        return truncate(entityName, {length: 50});
      }
      return truncate(entityName, {length: 15});
    },
    orderDateToString(folder) {
      const createdAt = get(folder, 'last_transaction.created_at');
      return createdAt ? this.formatMonthYear(createdAt) : 'Sem data';
    },
    getAdminUnitColor(unit) {
      if (!unit) return '#000000';
      return getColorByText(unit.abbreviation || unit.name);
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    selectedAdministrativeUnit() {
      return this.$store.getters.selectedAdministrativeUnit;
    },
    loading() {
      return this.$store.getters.loading;
    },
    folders() {
      const folders = this.$store.getters.folders;
      if (!folders || folders.length === 0) {
        return [];
      }

      let resultFolders = Array.isArray(folders) ? [...folders] : Object.values(folders);

      console.log(`Total de pastas enviadas: ${getFolderStatus}`);

      resultFolders = resultFolders.map(item => {
        if (item && item.last_transaction) {
          return {
            ...item,
            received_status: getFolderStatus(item),
            folder_section: "sent"
          };
        }
        return item;
      });

      return resultFolders;
    },
    groupedFolders() {
      const group = {};
      const orderedKeys = [];

      this.folders.forEach(folder => {
        const date = folder.last_transaction && folder.last_transaction.updated_at
          ? new Date(folder.last_transaction.updated_at)
          : (folder.updated_at ? new Date(folder.updated_at) : null);
        const key = date ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}` : 'Sem data';
        if (!group[key]) {
          group[key] = { folders: [folder], date: date };
          orderedKeys.push(key);
        } else {
          group[key].folders.push(folder);
        }
      });

      orderedKeys.sort((a, b) => {
        if (group[a].date && group[b].date) {
          return this.orderFilter.order === 'asc'
            ? group[a].date - group[b].date
            : group[b].date - group[a].date;
        }
        return 0;
      });

      const orderedGroups = {};
      orderedKeys.forEach(key => {
        const label = group[key].date
          ? this.formatMonthYear(group[key].date)
          : 'Sem data';
        orderedGroups[label] = group[key].folders;
      });

      return orderedGroups;
    },
    pages() {
      return this.$store.getters.foldersPagesCount;
    },
    foldersCount() {
      return this.$store.getters.activeTotalFolders;
    },
    pageStart() {
      return this.pageNumber * this.rowsPerPage - (this.rowsPerPage - 1);
    },
    pageStop() {
      return Math.min(
        this.pageStart + (this.rowsPerPage - 1),
        this.foldersCount
      );
    },
    searchText() {
      return this.$store.getters.searchText;
    },
    sentCounts() {
      return this.$store.getters.sentCounts;
    }
  },
  watch: {
    pageNumber: {
      handler: "getFolders",
      immediate: true
    },
    searchText(val) {
      if (val === null || val === "" || val.length > 2) {
        this.getFolders(false);
      }
    },
    orderFilter: {
      handler() {
        foldersService.clearCache();
        this.getFolders();
        this.$nextTick();
      }
    },
    // Observa mudanças na unidade administrativa selecionada
    selectedAdministrativeUnit: {
      handler() {
        // Reseta para página 1 e não dispara getFolders aqui,
        // pois o watcher do pageNumber já vai cuidar disso
        this.pageNumber = 1;
      }
    },
    // Impede recarga quando o número de pastas muda por outros motivos
    foldersCount: {
      handler() {
        // Não recarrega aqui, evitando requisições duplicadas
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/folder-list-margins.scss';

.dragging {
  background-color: #005ece;
}

.fade-cascade-enter-active {
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: 1;
  transform: translateY(0);
}
.fade-cascade-enter {
  opacity: 0;
  transform: translateY(20px);
}
.fade-cascade-enter-to {
  opacity: 1;
  transform: translateY(0);
}
.cascade-group > * {
  transition-delay: var(--cascade-delay, 0s);
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/views/folder/list/sent/Sent.vue